const messages = {
  pt: {
    translations: {
      header: {
        home: "Início",
        about: "Sobre",
        skills: "Habilidades",
        services: "Serviços",
        portfolio: "Portfólio",
        contact: "Contato",
      },
      home: {
        lg: "Language",
        pt: "Portuguese",
        en: "English",
      },
      data: {
        description:
          "Eu sou desenvolvedor front-end criativo. Moro em Joinville-SC, Brasil, e sou muito apaixonado e dedicada ao meu trabalho. Atualmente estudando ReactJs e React native.",
        button: "Diga olá",
      },
      scroll: {
        down: "descer",
      },
      about: {
        title: "Sobre mim",
        subtitle: "Minha introdução",
        description:
          "Desenvolvedor front-end. Crio páginas web com interface de usuário UI/UX, tenho menos de um ano de experiência mas tenho estudado todos os dias para crescer profissionalmente.",
      },
      info: {
        title1: "Experiência",
        title2: "Concluídos",
        title3: "Disponível",
        subtitle1: "1 ano de estudos",
        subtitle2: "+ 13 projetos",
        subtitle3: "Home office",
      },
      skills: {
        title: "Habilidades",
        subtitle: "Meu nível técnico",
      },
      front: {
        title: "Frontend developer",
        level: "Intermediário",
      },
      back: {
        title: "Backend Developer",
        level: "Básico",
      },
      services: {
        title: "Serviços",
        subtitle: "O que eu ofereço",
        view: "Ver mais",
        description:
          "Serviço de um ano de experiência. Oferecer um trabalho de qualidade para clientes e empresas.",
        info1: "Eu desenvolvo a interface do usuário.",
        info2: "Desenvolvimento de página web.",
        info3: "Crie interações de elemento UX.",
        info4: "Posicione a marca da sua empresa.",
        info5: "Design e Mockups de produtos para empresas.",
        view2: "Ver mais",
        description2:
          "Service a one year of experience. Providing quality work to clients and companies.",
        info6: "I develop the user interface.",
        info7: "Web page development.",
        info8: "Create UX element interactions.",
        info9: "Position your company brand.",
        info10: "Design and Mockups of products for companies.",
      },
      quali: {
        title: "Qualificação",
        subtitle: "Minha jornada pessoal",
        data1: "2022 - Presente",
        data2: "Outubro - 2022",
        data3: "Agosto - 2022",
        title2: "Pós graduação",
        subtitle2: "Engenharia Prevenção Combate a Incêndio - Unyaleya",
      },
      contact: {
        title: "Entrar em contato",
        subtitle: "Contato",
        title2: "Falar comigo",
        write: "Me escreva",
        profile: "Meu perfil",
        title3: "Escreva seu projeto...",
        name: "Nome",
        placeName: "Inserir seu nome",
        placeEmail: "Inserir seu e-mail",
        project: "Projeto",
        placeProject: "Escreva seu projeto...",
        button: "Enviar menssagem",
      },
      footer: {
        copy: "Todos os direitos reservados.",
      },
    },
  },
};

export { messages };
